import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { getRandomTextColor } from "../../util";

const TransactionGridItem = ({ component: Component, link, title, action }) => {
  const color = getRandomTextColor();

  return (
    <Fragment>
      {action ? (
        <button
          onClick={action}
          to={link}
          className="text-text-1/65 hover:text-primary "
        >
          <div className="p-3 flex flex-col items-center justify-center ">
            <div
              className={`bg-bkg2/50 hover:bg-bkg2 rounded-xl sm:rounded-2xl lg:rounded-3xl md  p-5 sm:p-8 lg:p-10 transition-all ease-in-out ${color} hover:text-primary `}
            >
              <Component size={40} />
            </div>
            <p className="text-nowrap text-center  ">{title}</p>
          </div>
        </button>
      ) : (
        <Link to={link} className="text-text-1/65 hover:text-primary ">
          <div className="p-3 flex flex-col items-center justify-center ">
            <div
              className={`bg-bkg2/50 hover:bg-bkg2 rounded-xl sm:rounded-2xl lg:rounded-3xl md  p-5 sm:p-8 lg:p-10 transition-all ease-in-out ${color} hover:text-primary `}
            >
              <Component size={40} />
            </div>
            <p className="text-nowrap text-center  ">{title}</p>
          </div>
        </Link>
      )}
    </Fragment>
  );
};

export default TransactionGridItem;
